<div class="error-tile">
    <div class="content-column"><div class="error-img"></div></div>
    <div class="content-column">
        <div class="error-header-code">404</div>
        <div class="error-message">We can't find the page you're looking for.</div>
    </div>
    <hr />
    <div class="error-button-container">
        <div class="error-button" [routerLink]="['/']">Go to homepage</div>
    </div>
</div>
